import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import IconStarTrue from "../iconComponents/IconStarTrue";
import IconStarFalse from "../iconComponents/IconStarFalse";
import IconTrash from "../iconComponents/IconTrash";
import IconEyeHidden from "../iconComponents/IconEyeHidden";
import IconEyeVisible from "../iconComponents/IconEyeVisible";
import { formatDateTimeToZone } from "../common/Helpers";
import DocStatusTag from "../common/DocStatusTag";


export function ProjectListItem(props) {

    const project = props.project;
    const project_favorites = useSelector(state => state.projects.project_favorites);
    const messages = useSelector(state => state.messages);

    const [trashIsHovered, setTrashIsHovered] = useState(false);
    const [starIsHovered, setStarIsHovered] = useState(false);
    const [rowIsHovered, setRowIsHovered] = useState(false);
    const [eyeIsClosed, setEyeIsClosed] = useState(project.hidden)

    const background = rowIsHovered === project.project_id ? " g9" : ""

    const projectIsFav = project_favorites.filter(projectFav => projectFav.project_id === project.project_id).length > 0;

    const color = project.project_status === "Draft" || project.hidden ? "g7-text" : "light-black";

    const starPathClass = starIsHovered ? "tc4-fill" : "g6-fill"


    const toggleFavourite = () => {
        props.handleToggleFavourite(project.project_id)
        setStarIsHovered(false)
    }

    const toggleVisibility = (project) => {
        setEyeIsClosed(!project.hidden)
        props.handleToggleVisibility(project)
    }


    // Regardless of hover, set eye to match true project visibility status when it updates or fails to update
    useEffect(() => {
        if (messages.filter(message => message.error).length > 0) {
            eyeIsClosed !== project.hidden && setEyeIsClosed(project.hidden);
        }  
    }, [messages]);
    useEffect(() => {
        eyeIsClosed !== project.hidden && setEyeIsClosed(project.hidden);
    }, [project.hidden, messages]);

    
    const trId = `${project.project_name}-${project.project_id}`
    const trFavStatus = projectIsFav ? "fav_true" : "fav_false"
    const eyeStatusClass = project.hidden ? "hidden_true" : "hidden_false"
    
    return (
        <tr 
            key={project.project_id} 
            className={`table-row ${trFavStatus}`}
            id={trId}
            onMouseEnter={() => setRowIsHovered(project.project_id)}
            onMouseLeave={() => setRowIsHovered(null)}
        >
            <td className={`${trFavStatus} typical rigid content1 ${color} first ${background}`}  
                style={{paddingRight: "4px"}} 
                onClick={() => toggleFavourite()}
                onMouseEnter={(e) => setStarIsHovered(true)} 
                onMouseLeave={(e) => setStarIsHovered(false)} >
                {!project.hidden && 
                    <>
                    {projectIsFav 
                    ? <IconStarTrue height="16px" pathClass={starPathClass} className="td-icon"/>
                    : <IconStarFalse height="16px" pathClass={starPathClass} className="td-icon"/>}
                    </>
                }
            </td>
            <td className={`typical flexi content1 ${color} name ${background}`} 
                onClick={(e) => props.handleSelectProjListItem(project.project_id)} 
                to-id={project.project_id}  
                style={{paddingLeft: "4px"}} >
                {project.project_name}
                <div></div>
            </td>
            <td className={`typical flexi content1 ${color} ${background}`}
                onClick={(e) => props.handleSelectProjListItem(project.project_id)}
                to-id={project.project_id} >
                {project.street}, {project.city}
            </td>
            <td className={`typical flexi content1 ${color} ${background}`} 
                onClick={(e) => props.handleSelectProjListItem(project.project_id)} 
                to-id={project.project_id} >
                {formatDateTimeToZone(project.project_date_created)}
            </td>
            <td className={`typical rigid content1 ${color} ${background}`} 
                onClick={(e) => props.handleSelectProjListItem(project.project_id)} 
                to-id={project.project_id} >
                <DocStatusTag status={project.project_status} fontSize="content3" >
                    {project.project_status}
                </DocStatusTag>
            </td>                       
            <td className={`typical rigid  hidedec ${background}`} 
                onClick={() => project.project_status === "Draft" && props.handleDelete(project.project_id)}
                onMouseEnter={(e) => setTrashIsHovered(project.project_id)} 
                onMouseLeave={(e) => setTrashIsHovered(null)} 
            >
                { project.project_status === "Draft" 
                ? <IconTrash  height="18px" pathClass={trashIsHovered === project.project_id ? "p-fill" : "g7-fill" } className="td-icon gap-left-s"  style={{marginTop: "-2px"}} />  
                : <></>
                }
            </td>
            <td className={`${eyeStatusClass} typical rigid  hidedec last-cell ${background}`} 
                onMouseEnter={() => setEyeIsClosed(!project.hidden)}
                onMouseLeave={() => setEyeIsClosed(project.hidden)}
                onClick={() => toggleVisibility(project)}
            >
                {eyeIsClosed
                ?<IconEyeHidden height="18px" pathClass="g7-fill" className="td-icon gap-left-s"  style={{marginTop: "-2px"}} />  
                :<IconEyeVisible height="18px" pathClass="g7-fill" className="td-icon gap-left-s"  style={{marginTop: "-2px"}} />  
                }
            </td>
        </tr> 
    )
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps )(ProjectListItem);